import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import '@/assets/styles/index.scss';

// Plugins ---------------------------------------------------------------------------
import VueTreeList from 'vue-tree-list';
Vue.use(VueTreeList);

import Vue2Filters from 'vue2-filters';
Vue.use(Vue2Filters);

import VueHtml2Canvas from 'vue-html2canvas';

Vue.use(VueHtml2Canvas);

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

// @ts-ignore
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
// const DateRangePicker = require('vue2-daterange-picker');
Vue.component('vue2-daterange-picker', DateRangePicker);

import wysiwyg from 'vue-wysiwyg';
Vue.use(wysiwyg, {
    hideModules: {
        justifyLeft: true,
        justifyCenter: true,
        justifyRight: true,
        headings: true,
        link: true,
        code: true,
        image: true,
        table: true,
        removeFormat: true,
        separator: true,
    },
}); // config is optional. more below
import 'vue-wysiwyg/dist/vueWysiwyg.css';

require('moment/locale/es');
// @ts-ignore
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
moment.tz.setDefault('America/Monterrey');
moment.updateLocale('es', {
    relativeTime: {
        future: 'en %s',
        past: 'Hace %s',
        s: 'un seg',
        ss: '%d seg',
        m: 'un min',
        mm: '%d min',
        h: 'una hora',
        hh: '%d horas',
        d: 'un día',
        dd: '%d días',
        M: 'un mes',
        MM: '%d meses',
        y: 'un año',
        yy: '%d años',
    },
});
Vue.use(VueMoment, { moment });

import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll);

import OneSignalVue from 'onesignal-vue'
Vue.use(OneSignalVue);

// Start App ------------------------------------------------------------------------
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: h => h(App),
    beforeMount() {
        this.$OneSignal.init({ appId: 'b07136b5-cc0b-4b2b-a1e6-34ed44497771' });
    }
}).$mount('#app');
